import React, {Component} from 'react';
import {connect} from 'react-redux';

import axios from "axios/index";

import urls from "../../../../utils/urls";
import {tokenHeader} from "../../../../utils/headers";
import {ajaxHandler} from "../../../../utils/errors";
import Modal from "../../../../components/modal";
import accept from './../../../../assets/accept.png';
import share from './../../../../assets/share.png';
import deleteicon from './../../../../assets/delete.png';
import ShareModal from "./components/shareModal/ShareModal";
import {
    fetchingData, fetchNotes, selectedNotes, newNoteAdded
} from "../../../../actions/visits_actions";


import './styles.scss';
import {bindActionCreators} from "redux";

class ActionButtons extends Component {

    constructor(props) {
        super(props);
        this.state = {
            type: ''
        }
    }

    onAcceptNote = () => {
        this.props.fetchingData(true);
        this.setState({showModal: false});
        let edit = this.props.notes.noteToEdit;
        let notes = "";
        if (this.props.type === "selected") {
            this.props.visits.selectedNotesIds.forEach((note, index) => {
                if (index === this.props.visits.selectedNotesIds.length - 1) {
                    notes += note;
                } else {
                    notes += note + ",";
                }
            });
        } else {
            notes += edit.id;
        }

        const accept_note_url = `${urls.API_ROOT}/api/v1/bulk-check-station-notes/`;
        axios
            .post(accept_note_url, {notes}, tokenHeader())
            .then(() => {
                this.props.fetchNotes(this.props.stations.selectedStation);
                this.props.selectedNotes([]);
                this.props.newNoteAdded()

            })
            .catch(ajaxHandler);

    };

    onDeleteNote = () => {
        this.props.fetchingData(true);
        this.setState({showModal: false});
        let edit = this.props.notes.noteToEdit;
        let notes = "";

        if (this.props.type === "selected") {
            this.props.visits.selectedNotesIds.forEach((note, index) => {
                if (index === this.props.visits.selectedNotesIds.length - 1) {
                    notes += note;
                } else {
                    notes += note + ",";
                }
            });
        } else {
            notes += edit.id
        }

        const delete_note_url = `${urls.API_ROOT}/api/v1/bulk-delete-station-notes/`;
        axios
            .post(delete_note_url, {notes}, tokenHeader())
            .then(() => {
                this.props.fetchNotes(this.props.stations.selectedStation);
                this.props.selectedNotes([]);
                this.props.newNoteAdded()

            })
            .catch(ajaxHandler);
    };

    showModal = (type) => {
        this.setState({showModal: true, type});
    };

    closeModal = () => {
        this.setState({showModal: false});
    };

    showShareModal = () => {
        this.setState({showShareModal: true});
    };

    closeShareModal = () => {
        this.setState({showShareModal: false});
    };

    render() {
        console.log(this.props.stations);
        let {type} = this.state;

        return (
            <div>
                <div className={"actions"}>
                    <img src={accept} alt={"notes"} onClick={() => this.showModal('accept')}
                         className={"icon-action"}/>
                    {this.props.stations.selectedStation !== 0 &&
                    <img src={share} alt={"notes"} onClick={this.showShareModal} className={"icon-action"}/>
                    }
                    <img src={deleteicon} alt={"notes"} onClick={() => this.showModal('delete')}
                         className={"icon-action"}/>
                </div>
                {this.state.showModal &&
                <Modal text={type === 'accept' ? `¿Desea completar la/s nota?` : "¿Desea eliminar la/s nota?"}
                       accept={type === 'accept' ? this.onAcceptNote : this.onDeleteNote} cancel={this.closeModal}
                       open={this.state.showModal}/>
                }
                {this.state.showShareModal && this.props.visits &&
                <ShareModal cancel={this.closeShareModal} type={this.props.type} open={this.state.showShareModal}/>}
            </div>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        visits: state.visits,
        notes: state.notes_actions,
        stations: state.stations
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        fetchingData, fetchNotes, selectedNotes, newNoteAdded
    }, dispatch);
};


export default connect(mapStateToProps, mapDispatchToProps)(ActionButtons);


// WEBPACK FOOTER //
// ./src/containers/site-visits/common/actionButtons/ActionButtons.js